export default {
  title01: "현재 날씨",
  title02: "24시간",
  title03: "10일 간의 날씨 예보 보기",
  title04: "대기질 지수(AQI)",
  title05: "모든 정보 보기",
  title06: "일출 및 일몰",
  title07: "달의 위상",
  title08: "다음 보름달",
  title09: "다음 신월",
  title10: "낮",
  title11: "밤",
  title12: "일출",
  title13: "일몰",
  title14: "월출",
  title15: "월몰",
  title16: "출처",
  title17: "시작",
  title18: "종료",
  title19: "현재 위치 사용",
  title20: "도시 검색",
  title21: "체감 온도",
  title22: "그늘 체감 온도",
  title23: "현재",
  title24: "오늘",
  title25: "일",
  title26: "월",
  title27: "화",
  title28: "수",
  title29: "목",
  title30: "금",
  title31: "토",
  title32: "로딩 중...",
  title33: "지금",
  title34: "시간별",
  title35: "일별",
  title36: "해와 달",
  title37: "대기 질",
  title38: "문의: xlf550402@gmail.com",
  title39: "개인정보 보호 정책",
  title40: "저작권 © comfortweather.com 2020 - 2026. 모든 권리 보유.",
  title41: "제공된 데이터:",
  title42: "최고 기온",
  title43: "최저 기온",
  title44: "동의",
  title45:
    "ComfortWeather를 이용해 주셔서 감사합니다. 고객님의 법적 권리와 이익을 보다 잘 보호하기 위해, 사용 전에 반드시 ",
  title46: "개인정보 처리방침",
  title47: " 을 주의 깊게 읽어 주시기 바랍니다.",
  title48: "",
  title49: "문의: xyjph123@gmail.com",
  title50: "저작권 © 24hweather.com 2020 - 2026. 모든 권리 보유.",
  title51:
    "24hweather를 이용해 주셔서 감사합니다. 고객님의 법적 권리와 이익을 보다 잘 보호하기 위해, 사용 전에 반드시 ",
  title52: "위치 변화에 따른 업데이트를 하시겠습니까? ",
  title53: "확인 ",
  title54: "취소 ",
  title55: "뒤로",
  title56: "뉴스",
  title57: "날씨 업데이트 ",
  title58: "날씨 업데이트 완료",
  title59: "전체 보기 ",
  title60: "저작권 © mobi321.com 2020 - 2026. 모든 권리 보유.",
  title61: "어제",
  title62: "내일",
  title63: "15일 간의 날씨 예보 보기",
  title64: "오늘의 세부 정보",
  title65: "Rahu Kaal",
  title66: "라이프스타일 지수",
  title67: "라이프스타일 지수",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "건조 어려움 ",
  title103: "건조가 느림",
  title104: "건조 잘 됨",
  title105: "건조 빠름 ",
  title106: "건조 매우 빠름",

  title107: "부적합 ",
  title108: "무난한 편",
  title109: "물놀이에 좋음",
  title110: "매우 적합",
  title111: "최적의 조건 ",

  title112: "건강에 좋은 환경",
  title113: "보통 수준",
  title114: "감기 걸릴 가능성 있음",
  title115: "감기 걸리기 쉬움",
  title116: "감기 매우 주의",

  title117: "부적합 ",
  title118: "다소 적합",
  title119: "야외 활동에 좋음 ",
  title120: "매우 적합",
  title121: "최적의 조건 ",

  title122: "매우 건조한 상태",
  title123: "건조할 가능성 높음",
  title124: "약간 건조함",
  title125: "건조할 가능성 낮음",
  title126: "건조할 가능성 매우 낮음",

  title127: "세차 비추천",
  title128: "보통",
  title129: "세차하기 좋은 날",
  title130: "세차하기 매우 좋은 조건",
  title131: "세차하기 최적의 조건",
};
